module.exports = __webpack_public_path__ + "04a8b0529c3e4bc9102fef2f90d8954b.jpg";